module.exports = __webpack_public_path__ + "static/img/3_02.98bb212c.png";